import {
  AbstractJsonLexer1em5xl1wqsdtw as AbstractJsonLexer,
  charToTokenClass1wja4xge82waq as charToTokenClass,
  tokenDescription3r6eqmtoxe76u as tokenDescription,
} from './AbstractJsonLexer.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  toString22rbkbhdb5cl2 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf1xbs558u7wr52 as indexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringJsonLexerWithComments3bzrli3gl2cah as StringJsonLexerWithComments } from './CommentLexers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonLexerClass;
function StringJsonLexer() {
  if (StringJsonLexerClass === VOID) {
    class $ extends AbstractJsonLexer() {
      constructor(source, configuration) {
        super(configuration);
        this.f2y_1 = source;
      }
      k2x() {
        return this.f2y_1;
      }
      l2x(position) {
        return position < this.k2x().length ? position : -1;
      }
      z2t() {
        var source = this.k2x();
        var cpos = this.y2m_1;
        $l$loop: while (!(cpos === -1) && cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.y2m_1 = cpos;
          return charToTokenClass(c);
        }
        this.y2m_1 = source.length;
        return 10;
      }
      v2t() {
        var current = this.y2m_1;
        if (current === -1)
          return false;
        var source = this.k2x();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
            continue $l$loop;
          }
          this.y2m_1 = current;
          return this.o2x(c);
        }
        this.y2m_1 = current;
        return false;
      }
      n2x() {
        var current = this.y2m_1;
        if (current === -1)
          return current;
        var source = this.k2x();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
          } else {
            break $l$loop;
          }
        }
        this.y2m_1 = current;
        return current;
      }
      g2u(expected) {
        if (this.y2m_1 === -1) {
          this.p2x(expected);
        }
        var source = this.k2x();
        var cpos = this.y2m_1;
        $l$loop: while (cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.y2m_1 = cpos;
          if (c === expected)
            return Unit_instance;
          this.p2x(expected);
        }
        this.y2m_1 = -1;
        this.p2x(expected);
      }
      m2u() {
        this.g2u(_Char___init__impl__6a9atx(34));
        var current = this.y2m_1;
        var closingQuote = indexOf(this.k2x(), _Char___init__impl__6a9atx(34), current);
        if (closingQuote === -1) {
          this.x2t();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected = tokenDescription(1);
          var position = false && this.y2m_1 > 0 ? this.y2m_1 - 1 | 0 : this.y2m_1;
          var s = this.y2m_1 === charSequenceLength(this.k2x()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.k2x(), position));
          var tmp$ret$1 = 'Expected ' + expected + ", but had '" + s + "' instead";
          this.o2s(tmp$ret$1, position);
        }
        var inductionVariable = current;
        if (inductionVariable < closingQuote)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (charCodeAt(this.k2x(), i) === _Char___init__impl__6a9atx(92)) {
              return this.consumeString2(this.k2x(), this.y2m_1, i);
            }
          }
           while (inductionVariable < closingQuote);
        this.y2m_1 = closingQuote + 1 | 0;
        return substring(this.k2x(), current, closingQuote);
      }
      o2u(keyToMatch, isLenient) {
        var positionSnapshot = this.y2m_1;
        try {
          if (!(this.z2t() === 6))
            return null;
          var firstKey = this.j2u(isLenient);
          if (!(firstKey === keyToMatch))
            return null;
          this.q2x();
          if (!(this.z2t() === 5))
            return null;
          return this.j2u(isLenient);
        }finally {
          this.y2m_1 = positionSnapshot;
          this.q2x();
        }
      }
    }
    initMetadataForClass($, 'StringJsonLexer');
    StringJsonLexerClass = $;
  }
  return StringJsonLexerClass;
}
function StringJsonLexer_0(json, source) {
  return !json.k2m_1.m2o_1 ? new (StringJsonLexer())(source, json.k2m_1) : new (StringJsonLexerWithComments())(source, json.k2m_1);
}
//region block: exports
export {
  StringJsonLexer_0 as StringJsonLexer3eu6xom7mrcfu,
  StringJsonLexer as StringJsonLexervr9dj3kex5li,
};
//endregion

//# sourceMappingURL=StringJsonLexer.mjs.map
